// extracted by mini-css-extract-plugin
module.exports = {"container":"MagicEcosystemSection_container__5Y3kU","title":"MagicEcosystemSection_title__rIx8O"};